'use strict';

var _ = require('lodash');
var DashboardCommonService = function DashboardCommonService(dataRetrieverService, dataRetrieverConstantsService) {
  var oneMarketSelectionState = false;
  var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.DASHBOARD_SCREEN, dataRetrieverConstantsService.MARKET_DASHBOARD_MODE);
  function getMarketsAndPosesBrush() {
    return _.get(dataRetriever.brushFilters(), 'markets-and-poses.filterArguments[0][0]');
  }
  function dataExistsForSelection() {
    return dataRetriever.retrieveComponentData('dashboard-panel').then(function (data) {
      oneMarketSelectionState = data && data.length !== 0;
      return oneMarketSelectionState;
    });
  }
  function isOneMarketSelected() {
    var brush = getMarketsAndPosesBrush();
    return brush && brush.market && brush.market.length === 1;
  }
  function selectionHasData() {
    return oneMarketSelectionState;
  }
  return {
    isOneMarketSelected: isOneMarketSelected,
    dataExistsForSelection: dataExistsForSelection,
    selectionHasData: selectionHasData,
    getMarketsAndPosesBrush: getMarketsAndPosesBrush
  };
};
DashboardCommonService.$inject = ['DataRetrieverService', 'DataRetrieverConstantsService'];
module.exports = DashboardCommonService;